import css from 'styled-jsx/css';

export default css`
  :global(html) {
    scroll-behavior: smooth !important;
  }
  :global(iframe) {
    color-scheme: auto;
    padding-bottom: 70px;
  }
  :global(.kayako-messenger) {
    bottom: 40px;
  }
  .content-container {
    display: flex;
    justify-content: space-between;
  }
  .buttons-container {
    display: flex;
  }
  .label {
    min-height: 20px;
    font-weight: 600;
  }
  .catalogs :global(.box .body) {
    width: 100%;
  }
  .confirm {
    margin: 1rem 0;
  }
  .wrapper-gallery {
    margin-bottom: 10px;
    gap: 16px;
    overflow: hidden;
  }
  .wrapper-gallery > div img {
    border-radius: 10px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    position: relative;
  }
  :global(.carousel-container) {
    position: relative;
  }
  :global(.p-md) {
    padding: 0.5em 0em;
    margin: 0px 9px;
  }
  :global(.pt-md) {
    padding: 0.5em 0em;
  }
  :global(.slider-container ul) {
    display: flex !important;
    gap: 15px;
  }

  :global(.carousel-slide img) {
    border-radius: 10px;
    box-shadow: var(--shadow-light);
    cursor: pointer;
    transition: 0.3s;
  }
  :global(.carousel-slide img):hover {
    box-shadow: var(--shadow-blue);
    transform: translateY(-2px);
  }
  :global(.carousel__dot-group) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  :global(.carousel__dot-group button) {
    height: 5px;
    border-radius: 0px;
    background: var(--grey-lighter);
  }
  :global(.carousel__dot-group button.carousel__dot--selected) {
    background: var(--primary);
  }
  :global(.carousel-button) {
    position: absolute;
    top: 50%;
    transform: translate(-0%, -50%);
    border: solid thin #ccc3;
    background: rgba(255, 255, 255, 0.65);
    color: black;
    border-radius: 2px;
    height: 40px;
  }
  :global(.carousel-button-left) {
    left: -9px;
  }
  :global(.carousel-button-right) {
    right: -9px;
  }
  .chat {
    position: fixed;
    bottom: 20px;
    right: 25px;
    z-index: 11000000000;
  }
  .mobile-chat {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 11000000000;
  }
  .chat img,
  .mobile-chat img {
    height: 45px;
    cursor: pointer;
  }
  .transparent-chat {
    background: transparent;
    height: 60px;
    width: 60px;
  }
  @media only screen and (max-width: 470px) {
    :global(iframe) {
      color-scheme: auto;
      padding-bottom: 0px;
    }
    .hide-chat {
      display: none;
    }
    .show-chat {
      display: block;
    }
  }
  @media only screen and (max-width: 768px) {
    :global(.pagination) {
      margin-bottom: 60px;
      margin-top: 30px !important;
      justify-content: center !important;
    }
  }
  :global(.info-box) {
    padding: 0px 12px;
    margin-bottom: 24px;
  }
  .info-card :global(.card) {
    padding: 0px;
    margin: 0px;
  }
  :global(.product-description-info) {
    border: solid thin rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: var(--background-utils);
    border-left: solid 5px var(--info);
    padding: 10px;
  }

  :global(.product-description-info) p {
    font-size: 14px;
    line-height: 20px;
    color: var(--foreground);
  }

  .product-description-info :global(.icon) {
    color: var(--info);
  }

  :global(.highlighted-brand) {
    font-weight: 600;
    font-size: 15px;
    padding-top: 15px;
  }
  .divider-right {
    border-right: solid thin #ccc;
    height: 60px;
  }
  .divider-bottom {
    border-bottom: solid thin #ccc5;
    width: 100%;
  }
  .box-step {
    padding: 0px 20px;
  }
  .box-step p {
    font-weight: 500;
  }
  :global(.divider-bottom) {
    width: 100%;
    height: 0.5px;
    background: #ccc4;
  }
  :global(.circle) {
    border-radius: 50px;
    background: var(--background);
    padding: 1em;
    height: 75px;
    width: 75px;
    border: solid thin #ccc2;
  }
  :global(.modal-free p) {
    font-size: 15px;
    font-weight: 400;
    text-align: center;
  }
  :global(.modal-free h3) {
    color: var(--primary);
  }
  .empty-card-wrapper {
    background: var(--background-utils);
    border-radius: 10px;
    overflow: unset;
    margin: 0 0 var(--margin-md) 0;
    border: solid 1px var(--card-border);
    padding: 2em;
  }
  .empty-card-wrapper img {
    width: 160px;
  }
  :global(.focusRing___1airF.carousel__slide-focus-ring) {
    outline: none !important;
  }
  .cashback {
    border: 1px solid var(--card-border);
    padding: 0.3em 0.6em;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.75);
  }
`;
